export default {
  success: '#58A144',
  defaultColor: '#3776e9',
  sky: '#F8F9FA',
  persianred: '#D1392B',
  darkestpurple: '#594896',
  darkpurple: '#84378C',
  purple: 'rgb(94, 88, 161)',
  darkpink: '#DD488D',
  darkorange: '#E67F3C',
  lightorange: '#F4C370',
  darkestblue: '#273188',
  darkblue: '#384296',
  black: '#000',
  white: '#fff',
  lightestgreen: '#AACCB1',
  lightergreen: '#87BDB1',
  lightgreen: '#69B3Af',
  greenyellow: '#C2DBB3',
  lightgreenyellow: '#D3E2B6',
  neongreen_2: '#60F4A0',
  neongreen_1: '#07D1BF',
  greenblue: '#0295CE',
  darkergreenblue: '#0370B7',
  darkestgreenblue: '#004682',
  lighestgraygreen: '#D7E6E6',
  lightergraygreen: '#00A989',
  darkergraygreen: '#3C494F',
  darkestgraygreen: '#263137'
}
